/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { StudySitePerformanceDto } from '../models/StudySitePerformanceDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { request as __request } from '../core/request';

export class StudySitePerformanceService {

    /**
     * Get study site performance
     * @param studyId
     * @param siteId
     * @returns StudySitePerformanceDto
     * @throws ApiError
     */
    public static studySitePerformanceControllerGet(
        studyId: string,
        siteId: string,
    ): CancelablePromise<StudySitePerformanceDto> {
        return __request({
            method: 'GET',
            path: `/study-site-performace/${studyId}/${siteId}`,
        });
    }

}